<template>
  <div>
    <Header />

    <div class="container-fluid users-container">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <DivvyAdminSidebar />
        </div>

        <transition appear name="fade">
          <div class="col-md-9 right-container" v-if="getUpdatePointsResult">
            <div class="col-md-12 pt-4">
              <h3>User points updated</h3>
              <br />

              <div class="row">
                <div class="col-md-6">
                  <table class="table table-bordered table-striped">
                    <tbody>
                      <tr>
                        <td><strong>User:</strong></td>
                        <td class="text-right">{{ Name }}</td>
                      </tr>
                      <tr>
                        <td><strong>Previous Points:</strong></td>
                        <td class="text-right">
                          {{ getUpdatePointsResult.previousPoints }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>{{ Type }}:</strong>
                        </td>
                        <td class="text-right">
                          {{ getUpdatePointsResult.pointsAdded }}
                        </td>
                      </tr>
                      <tr>
                        <td><strong>New Total Points:</strong></td>
                        <td class="text-right">
                          {{ getUpdatePointsResult.totalPoints }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <router-link
                class="btn btn-primary"
                :to="{ name: 'Users' }"
                @click.native="scrollToTop"
              >
                User Manager
              </router-link>
            </div>
          </div>

          <div class="col-md-9 right-container" v-if="getCreditPointsResult">
            <div class="col-md-12 pt-4">
              <h3>User points updated</h3>
              <br />

              <div class="row">
                <div class="col-md-6">
                  <table class="table table-bordered table-striped">
                    <tbody>
                      <tr>
                        <td><strong>User:</strong></td>
                        <td class="text-right">{{ Name }}</td>
                      </tr>
                      <tr>
                        <td><strong>Previous points:</strong></td>
                        <td class="text-right">
                          {{ getCreditPointsResult.previousPoints }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Credit:</strong>
                        </td>
                        <td class="text-right">
                          {{ getCreditPointsResult.creditedPoints }}
                        </td>
                      </tr>
                      <tr>
                        <td><strong>New total points:</strong></td>
                        <td class="text-right">
                          {{ getCreditPointsResult.totalPoints }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <button class="btn btn-primary" @click="updateRecords">
                User Manager
              </button>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import DivvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";

export default {
  name: "UserPointChangeScreen",
  props: ["Name", "Type"],
  components: {
    DivvyAdminSidebar,
    Header,
    Footer,
  },

  computed: {
    getUpdatePointsResult() {
      return this.$store.getters["manageUsers/getUpdatePointsResult"];
    },
    getCreditPointsResult() {
      return this.$store.getters["manageUsers/getCreditPointsResult"];
    },
  },

  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch("divvyAdminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "usersmodule",
        activeMenu: this.activeMenu ? this.activeMenu : "clientusermanagement",
      });
    },
    updateRecords() {
      this.$router.push({ name: "Users" });
    },
  },

  created() {
    this.setActiveMenuItem();
  },

  destroyed() {
    this.$store.state.manageUsers.updatePointsResult = null;
    this.$store.state.manageUsers.creditPointsResult = null;
  },
};
</script>

<style lang="scss" scoped>
.users-container {
  min-height: 100%;
  margin: -14px 0 0 0;
}
</style>
